import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedTime, IntlProvider } from 'react-intl';
import { Link } from 'react-router-dom';

import i18n from '../../../i18n/i18n';

import Slider from '../../../components/Slider/Slider';
import Placeholder from '../../../components/Placeholder';

import {
  Section,
  SectionInner,
  List,
  SliderWrapper,
  ItemContent,
  InfoList,
  SeminarLink,
  Keys,
  Values,
  Item,
  SeminarTitle,
  Title,
} from './RecommendedSeminars.style';

const generateSeminars = (seminars, locale, copy) =>
  seminars.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).map(seminar => {
    const dateObj = new Date(seminar.date);
    const day = dateObj.getDate();
    const month = dateObj.getMonth();
    const monthName = i18n[locale].months[month];
    const year = dateObj.getFullYear();
    const yyyymmdd = `${year}/${("0" + (month + 1)).slice(-2)}/${("0" + day).slice(-2)}`;
    const seminarDurationHours = seminar.duration.split(':')[0];
    const seminarDurationMinutes = seminar.duration.split(':')[1];
    const duration =
      parseInt(seminarDurationHours, 10) * 60 * 60 * 1000 + parseInt(seminarDurationMinutes, 10) * 60 * 1000;

    return (
      <Item key={seminar.entryId}>
        <ItemContent>
          <div>
            <SeminarTitle>{seminar.title}</SeminarTitle>
          </div>
          <InfoList>
            <Keys>
              <p>{`${copy.date}: `}</p>
              <p>{`${copy.time}: `}</p>
              <p>{`${copy.instructor}: `}</p>
            </Keys>
            <Values>
              <p>
                {yyyymmdd}
              </p>
              <p>
                <IntlProvider locale={locale.split('_')[0]}>
                  <React.Fragment>
                    <FormattedTime value={dateObj} /> -{' '}
                    <FormattedTime value={new Date(dateObj.getTime() + duration)} />
                  </React.Fragment>
                </IntlProvider>
              </p>
              <p>{seminar.instructor.name}</p>
            </Values>
          </InfoList>
          <SeminarLink>
            <p style={{opacity: 0}}>{copy.sign_up}</p>
          </SeminarLink>
        </ItemContent>
      </Item>
    );
  });

const RecommendedSeminars = ({ copy, locale, seminars }) => (
  <Section>
    <SectionInner>
      <Title>{copy.browse_more_seminars || <Placeholder w="200px" h="20px" />}</Title>
      <List>
        {seminars.length === 0 ? <Placeholder h="400px" w="100%" /> : generateSeminars(seminars, locale, copy)}
      </List>
      <SliderWrapper>
        {seminars.length === 0 ? (
          <Placeholder h="190px" w="100%" />
        ) : (
          <Slider options={{ loop: false }} dots={false}>
            {generateSeminars(seminars, locale, copy)}
          </Slider>
        )}
      </SliderWrapper>
    </SectionInner>
  </Section>
);

RecommendedSeminars.defaultProps = {
  copy: {},
};

RecommendedSeminars.propTypes = {
  copy: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
  seminars: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      city: PropTypes.string,
      date: PropTypes.string,
      name: PropTypes.string,
      category: PropTypes.string,
      targetAudience: PropTypes.arrayOf(PropTypes.string),
      photoGallery: PropTypes.arrayOf(PropTypes.shape({})),
      description: PropTypes.string,
      slug: PropTypes.string,
    })
  ).isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopySeminarPage,
  locale: state.locale,
});

export default connect(mapState)(RecommendedSeminars);



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/RecommendedSeminars/RecommendedSeminars.js